const defaultOfertaForm = {
    fechaAgendado: null,
    isp: '',
    razonNoInteresado: '',
    tipoIva: '',
    precioAnterior: 0,
    precioTotal: 0,
    paquetes: [],
    numeroComercial: null
}

export default defaultOfertaForm;
